module.exports = __webpack_public_path__ + "img/m.9f296183.svg";